module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department_sp08-8c88169f1c06970033eb4c3b4cc75ff7.jpg";